// LUMINA · pages/NotFoundPage.jsx — 404 catch-all

import React from "react";
import { useNavigate } from "react-router-dom";
import { C } from "../constants/baziData";

const GD = "#D4AF37";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh",
      background: C.bg || "#FDFBF7",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Inter','Noto Sans SC',sans-serif",
      padding: "40px 24px",
      textAlign: "center",
    }}>
      <div style={{
        fontSize: 72,
        color: GD,
        fontWeight: 300,
        letterSpacing: 8,
        marginBottom: 8,
        fontFamily: "'Cormorant Garamond',serif",
      }}>
        404
      </div>
      <div style={{
        width: 60,
        height: 1,
        background: `linear-gradient(90deg, transparent, ${GD}, transparent)`,
        margin: "0 auto 24px",
      }} />
      <div style={{
        fontSize: 16,
        color: "rgba(0,0,0,0.55)",
        letterSpacing: 1,
        marginBottom: 32,
        lineHeight: 1.7,
      }}>
        Page not found · 页面未找到
      </div>
      <button
        onClick={() => navigate("/")}
        style={{
          padding: "10px 32px",
          borderRadius: 8,
          border: `1px solid ${GD}`,
          background: "transparent",
          color: GD,
          fontSize: 13,
          cursor: "pointer",
          letterSpacing: 1,
          transition: "all .2s",
        }}
        onMouseEnter={(e) => {
          e.target.style.background = GD;
          e.target.style.color = "#fff";
        }}
        onMouseLeave={(e) => {
          e.target.style.background = "transparent";
          e.target.style.color = GD;
        }}
      >
        Back to Home · 返回首页
      </button>
    </div>
  );
}
